import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { retrieveUrl } from "../game-state/games.functions";
import { Game } from "../game-state/games-overview.type";
import { selectScoreFactory } from "../game-state/user-profile.slice";

export const GameSelectionButton = ({
  gameId,
  game,
  onClick,
}: {
  gameId: string;
  game: Game;
  onClick: () => void;
}) => {
  const storage = useAppSelector((state) => state.storageState);
  const scores: string[] = useAppSelector(
    useMemo(() => selectScoreFactory(gameId), [gameId])
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(retrieveUrl(`data/${game.imageUrl}`));
  }, [game, dispatch]);

  return (
    <div className="bg-blue-600 rounded">
      <button
        onClick={onClick}
        className="w-full h-28 bg-cover bg-center font-bold text-2xl shadow-md rounded flex justify-center items-center text-white transform transition duration-200 hover:scale-105 cursor-pointer"
        style={{
          backgroundImage: `url(${storage[`data/${game.imageUrl}`]})`,
        }}
      >
        <i className={"fa fa-2x mr-4 z-10 " + game.icon} />
        <div className="block text-center z-10">
          <p className="mb-1">{game.title}</p>
          <div className="bg-yellow-500 rounded-3xl py-1 px-3 border-white border-2">
            {scores.slice(0, 4).map((icon, index) => {
              return <i key={index} className={`${icon} mr-1`} />;
            })}
            <i className={scores[4]} />
          </div>
        </div>
        <div className="w-full rounded-b h-16 bottom-0 absolute opacity-60 bg-gradient-to-b from-transparent to-black" />
      </button>
    </div>
  );
};
